import {
  AbstractControl,
  UntypedFormArray,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';
import { toExternalImageUrl } from './image-url';

export function createDateValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (!value) {
      return null;
    }

    const isValidDate =
      /^([0][1-9]|[12][0-9]|3[01])[.]([0][1-9]|1[012])[.]\d{4}( (0?[1-9]|[1][0-9]|[2][0-3])[:]([0-5][0-9])?)?$/.test(
        value
      );

    return !isValidDate ? { validDate: true } : null;
  };
}

export function hexColorValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (!value) {
      return null;
    }
    const isValidHexColorRegex = /^#([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$/;
    const isValid = isValidHexColorRegex.test(value);
    return !isValid ? { validColor: { value: control.value } } : null;
  };
}

export function requiresAtLeastOneUser(): ValidatorFn {
  return (array: UntypedFormArray): ValidationErrors | null => {
    // const value = control.value;
    const controlValues: boolean[] = array.controls
      .map((control) => {
        return control.value;
      })
      .filter(Boolean);

    const isValid = controlValues.length > 0;
    return !isValid ? { requiresAtLeastOneUser: { value: isValid } } : null;
  };
}

export function validTime(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (!value) {
      return null;
    }
    const isValidHexColorRegex = /\b([01]?[0-9]|2[0-3]):[0-5][0-9]\b/;
    const isValid = isValidHexColorRegex.test(value);
    return !isValid ? { validTime: { value: control.value } } : null;
  };
}

export function validURL(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    return toExternalImageUrl(control.value) === null
      ? { invalidUrl: true }
      : null;
  };
}

export function formatTooltipValue(
  value: number,
  maxDecimals: number = 3
): string {
  if (value === 0) {return '0';}

  const absValue = Math.abs(value);

  // Determine appropriate decimal places based on value magnitude
  let decimals: number;

  if (absValue >= 100) {
    decimals = 0; // No decimals for large values
  } else if (absValue >= 10) {
    decimals = 1; // 1 decimal for medium values
  } else if (absValue >= 1) {
    decimals = 2; // 2 decimals for small values
  } else if (absValue >= 0.1) {
    decimals = 3; // 3 decimals for very small values
  } else if (absValue >= 0.01) {
    decimals = 4; // 4 decimals for tiny values
  } else {
    decimals = Math.min(maxDecimals, 5); // Cap at 5 decimals for extremely small values
  }

  return value.toFixed(decimals);
}
